export const START_RECORDING = 'START_RECORDING';
export const STOP_RECORDING = 'STOP_RECORDING';
export const RECORDING_ERROR = 'RECORDING_ERROR';
export const SET_RECORDING_STREAM = 'SET_RECORDING_STREAM';
export const SET_PERMISSIONS_ERROR = 'SET_PERMISSIONS_ERROR';
export const SET_RECORDED_RESULT = 'SET_RECORDED_RESULT';
export const CLEAR_RECORDING_STREAM = 'CLEAR_RECORDING_STREAM';
export const CLEAR_RECORDED_RESULT = 'CLEAR_RECORDED_RESULT';
export const CLEAR_PERMISSIONS_ERROR = 'CLEAR_PERMISSIONS_ERROR';
export const SET_MIC_CHECK_PASSED = 'SET_MIC_CHECK_PASSED';
export const START_OFFLINE_AUDIO_SAVING = 'START_OFFLINE_AUDIO_SAVING';
export const END_OFFLINE_AUDIO_SAVING = 'END_OFFLINE_AUDIO_SAVING';
export const TOGGLE_IS_VR_RESULT_PROCESSING_TIMEOUT = 'TOGGLE_IS_VR_RESULT_PROCESSING_TIMEOUT';
export const INCREMENT_MIC_TEST_ATTEMPT_COUNT = 'INCREMENT_MIC_TEST_ATTEMPT_COUNT';
export const CLEAR_MIC_TEST_ATTEMPT_COUNT = 'CLEAR_MIC_TEST_ATTEMPT_COUNT';
export const SHOW_RECORDING_HELP_POPUP = 'SHOW_RECORDING_HELP_POPUP';
export const HIDE_RECORDING_HELP_POPUP = 'HIDE_RECORDING_HELP_POPUP';

export const toggleIsVrResultProcessingTimeout = () => ({ type: TOGGLE_IS_VR_RESULT_PROCESSING_TIMEOUT });

export const startRecording = () => ({ type: START_RECORDING });

export const stopRecording = () => ({ type: STOP_RECORDING });

export const setRecordingError = recordingError => ({ type: RECORDING_ERROR, recordingError });

export const setRecordingStream = recordingStream => ({ type: SET_RECORDING_STREAM, recordingStream });

export const clearRecordingStream = () => ({ type: CLEAR_RECORDING_STREAM });

export const clearRecordedResult = () => ({ type: CLEAR_RECORDED_RESULT });

export const setPermissionsError = permissionsError => ({ type: SET_PERMISSIONS_ERROR, permissionsError });

export const setRecordedResult = recordedResult => async dispatch => dispatch({
    type: SET_RECORDED_RESULT,
    recordedResult,
});

export const clearPermissionsError = () => ({ type: CLEAR_PERMISSIONS_ERROR });

export const setMicCheckPassed = () => ({ type: SET_MIC_CHECK_PASSED });

export const startOfflineAudioSaving = () => ({ type: START_OFFLINE_AUDIO_SAVING });

export const endOfflineAudioSaving = () => ({ type: END_OFFLINE_AUDIO_SAVING });

export const incrementMicTestAttemptCount = () => ({ type: INCREMENT_MIC_TEST_ATTEMPT_COUNT });

export const clearMicTestAttemptCount = () => ({ type: CLEAR_MIC_TEST_ATTEMPT_COUNT });

export const hideRecordingHelpPopup = () => ({ type: HIDE_RECORDING_HELP_POPUP });
